import { render, staticRenderFns } from "./hotSaleList.vue?vue&type=template&id=5e5cffe3&scoped=true&"
import script from "./hotSaleList.vue?vue&type=script&lang=js&"
export * from "./hotSaleList.vue?vue&type=script&lang=js&"
import style0 from "./hotSaleList.vue?vue&type=style&index=0&id=5e5cffe3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5cffe3",
  null
  
)

export default component.exports